import { UserMessage, UserMessageType } from 'app/types-shared';
import { getUserMessage } from './get-user-message';

export const ACTION = {
  DISPLAY_USER_MESSAGE: 'USER_NOTIFICATION:DISPLAY_MESSAGE',
  DELETE_USER_MESSAGE: 'USER_NOTIFICATION:DELETE_MESSAGE'
};
export class ErrorNotification {
  public type: string = ACTION.DISPLAY_USER_MESSAGE;
  public message: UserMessage;

  constructor(message: string | UserMessage[]) {
    this.message = { id: Date.now(), type: UserMessageType.error, message: getUserMessage(message) };
  }
}

export class SuccessNotification {
  public type: string = ACTION.DISPLAY_USER_MESSAGE;
  public message: UserMessage;

  constructor(message: string | UserMessage[]) {
    this.message = { id: Date.now(), type: UserMessageType.success, message: getUserMessage(message) };
  }
}

export class InfoNotification {
  public type: string = ACTION.DISPLAY_USER_MESSAGE;
  public message: UserMessage;

  constructor(message: string | UserMessage[]) {
    this.message = { id: Date.now(), type: UserMessageType.info, message: getUserMessage(message) };
  }
}

/**
 * Internal usage. After a timeout the user message is removed from store.
 */
export class DeleteUserMessage {
  public type: string = ACTION.DELETE_USER_MESSAGE;
  public message: UserMessage;

  constructor(message: UserMessage) {
    this.message = message;
  }
}
